'use es6';

import { fromJS, Map as ImmutableMap } from 'immutable';
import http from 'hub-http/clients/apiClient';
const TEMPLATES_URL = 'reporting-discovery/v1/report-template';
let templates = ImmutableMap();
let hasRequestedAllTemplates = false;
const fetchReportTemplates = () => http.get(TEMPLATES_URL, {
  query: {
    statuses: ['ACTIVE'],
    hydrate: []
  }
});
const normalizeTemplate = template => fromJS(template).remove('id');
export const getReportTemplates = () => {
  if (!hasRequestedAllTemplates) {
    hasRequestedAllTemplates = true;
    return fetchReportTemplates().then(results => {
      const templatesByKey = results.reduce((memo, template) => memo.set(template.templateKey, normalizeTemplate(template)), ImmutableMap());
      templates = templates.merge(templatesByKey);
      return templates;
    });
  }
  return Promise.resolve(templates);
};
export const getReportTemplateByKey = templateKey => {
  if (!templates.get(templateKey)) {
    return http.get(`${TEMPLATES_URL}/template-key/${templateKey}`).then(template => {
      const normalizedTemplate = normalizeTemplate(template);
      templates = templates.set(templateKey, normalizedTemplate);
      return normalizedTemplate;
    });
  }
  return Promise.resolve(templates.get(templateKey));
};
export const setReportTemplates = fetchedTemplates => {
  templates = fetchedTemplates;
};